// import {
//   BookCourtData,
//   BookCourtSection,
//   BookCourtSectionEnum,
// } from "../types/types";

import { CirclePlayerMap, CirclePlayersList, Player } from "../apis/types";
import { Strings } from "./strings";
import yellowGuest from "../assets/yellow_guest.png";
import greenGuest from "../assets/green_guest.png";
import { UltraServiceLocation, UltraServiceLocationUrl } from "../types/types";

// export const BookCourtSections: BookCourtSection[] = [
//   {
//     id: BookCourtSectionEnum.SELECT_DATE_TIME,
//     title: "Select the day and time you can play",
//     isExpanded: true,
//   },
//   {
//     id: BookCourtSectionEnum.SELECT_CIRCLE,
//     title: "Select your circle you want play with",
//     isExpanded: false,
//   },
//   {
//     id: BookCourtSectionEnum.PAYMENT,
//     title: "Price for this booking",
//     isExpanded: false,
//   },
// ];
//
// export const CourtBookingData: BookCourtData = {
//   sections: BookCourtSections,
// };

export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const PLAYER_PLACEHOLDER_WIDTH = 76;

export const PLAYER_PLACEHOLDER_HEIGHT = 106;

export const TOTAL_PLAYERS_IN_MATCH = 4;
export const TOTAL_PLAYERS_IN_MATCH_SINGLES = 2;

// export const PLAYER_CIRCLE_GRAPH_VALUES: PlayerCircleGraph[] = [
//   { id: 1, value: Strings.AUDIENCE_FIRST_CATEGORY },
//   { id: 2, value: Strings.AUDIENCE_SECOND_CATEGORY },
//   { id: 3, value: Strings.AUDIENCE_THIRD_CATEGORY },
//   { id: 4, value: Strings.AUDIENCE_FOURTH_CATEGORY },
// ];

export const circlePlayerGraphSize = {
  innerCircle: 150,
  firstCircle: 250,
  secondCircle: 350,
  thirdCircle: 450,
};

export enum PlayerCircleGraphEnum {
  INNER = 1,
  FIRST = 2,
  SECOND = 3,
  THIRD = 4,
  NONE = 5,
}

export namespace PlayerCircleGraphEnum {
  export function getTitle(circle: PlayerCircleGraphEnum): string {
    switch (circle) {
      case PlayerCircleGraphEnum.INNER:
        return "Inner";
      case PlayerCircleGraphEnum.FIRST:
        return "1st";
      case PlayerCircleGraphEnum.SECOND:
        return "2nd";
      case PlayerCircleGraphEnum.THIRD:
        return "3rd";
      default:
        return "";
    }
  }
  export function getPlayers(
    circle: PlayerCircleGraphEnum,
    circlePlayerResponse?: CirclePlayersList
  ): CirclePlayerMap | undefined {
    switch (circle) {
      case PlayerCircleGraphEnum.INNER:
        return circlePlayerResponse?.innerCirclePlayers;
      case PlayerCircleGraphEnum.FIRST:
        return circlePlayerResponse?.firstCirclePlayers;
      case PlayerCircleGraphEnum.SECOND:
        return circlePlayerResponse?.secondCirclePlayersWithUltraRating;
      case PlayerCircleGraphEnum.THIRD:
        return circlePlayerResponse?.thirdCirclePlayersWithUltraRating;
      default:
        return undefined;
    }
  }
  export function getTotalPlayerCount(
    circle: PlayerCircleGraphEnum,
    circlePlayerResponse?: CirclePlayersList
  ): string | undefined {
    switch (circle) {
      case PlayerCircleGraphEnum.INNER:
        return (circlePlayerResponse?.innerCirclePlayers.totalCount ?? 0) > 1000
          ? "1000+"
          : (circlePlayerResponse?.innerCirclePlayers.totalCount ?? 0) > 100
          ? "100+"
          : circlePlayerResponse?.innerCirclePlayers.totalCount.toString();
      case PlayerCircleGraphEnum.FIRST:
        return (circlePlayerResponse?.firstCirclePlayers.totalCount ?? 0) > 1000
          ? "1000+"
          : (circlePlayerResponse?.firstCirclePlayers.totalCount ?? 0) > 100
          ? "100+"
          : circlePlayerResponse?.firstCirclePlayers.totalCount.toString();
      case PlayerCircleGraphEnum.SECOND:
        return (circlePlayerResponse?.secondCirclePlayersWithUltraRating
          .totalCount ?? 0) > 1000
          ? "1000+"
          : (circlePlayerResponse?.secondCirclePlayersWithUltraRating
              .totalCount ?? 0) > 100
          ? "100+"
          : circlePlayerResponse?.secondCirclePlayersWithUltraRating.totalCount.toString();
      case PlayerCircleGraphEnum.THIRD:
        return (circlePlayerResponse?.thirdCirclePlayersWithUltraRating
          .totalCount ?? 0) > 1000
          ? "1000+"
          : (circlePlayerResponse?.thirdCirclePlayersWithUltraRating
              .totalCount ?? 0) > 100
          ? "100+"
          : circlePlayerResponse?.thirdCirclePlayersWithUltraRating.totalCount.toString();
      default:
        return undefined;
    }
  }
}

export const BOOKING_FEES_SERVICE_ID = 4;

export const ULTRA_AI_PLAYERS_ID = [
  { id: "86467", icon: yellowGuest },
  { id: "87257", icon: greenGuest },
  { id: "87258", icon: yellowGuest },
];

export const GUEST_PLAYERS: Player[] = [
  {
    userId: parseInt(ULTRA_AI_PLAYERS_ID[0].id, 10),
    name: Strings.GUEST_PLAYER,
    email: "",
    userImageUrl: ULTRA_AI_PLAYERS_ID[0].icon,
    clubRank: 0,
    matchesWon: 0,
    userRating: 0,
    count: 0,
    lastMatchDate: "",
    isGuestPlayer: true,
    isAIPlayer: false,
  },
  {
    userId: parseInt(ULTRA_AI_PLAYERS_ID[1].id, 10),
    name: Strings.GUEST_PLAYER,
    email: "",
    userImageUrl: ULTRA_AI_PLAYERS_ID[1].icon,
    clubRank: 0,
    matchesWon: 0,
    userRating: 0,
    count: 0,
    lastMatchDate: "",
    isGuestPlayer: true,
    isAIPlayer: false,
  },
  {
    userId: parseInt(ULTRA_AI_PLAYERS_ID[2].id, 10),
    name: Strings.GUEST_PLAYER,
    email: "",
    userImageUrl: ULTRA_AI_PLAYERS_ID[2].icon,
    clubRank: 0,
    matchesWon: 0,
    userRating: 0,
    count: 0,
    lastMatchDate: "",
    isGuestPlayer: true,
    isAIPlayer: false,
  },
];

export const COST_PER_PLAYER = 57.5;
export const COST_PER_PLAYER_SERVICE_ID = 4;

export enum BookingPaymentType {
  WALLET = 1,
  CARD = 2,
  EXTERNAL_WALLET = 3,
}

export enum ULTRA_SERVICE_LOCATION_ENUM {
  MAGIC_CITY = 1,
  AVENTURA,
  BRICKBELL,
}

export enum ULTRA_SERVICE_ENUM {
  BOOK_COURT = 1,
  BOOK_CLINIC,
  BOOK_LESSON,
  BOOK_EVENT,
  BOOK_TOURNAMENT,
}

export const UltraServiceLocations: UltraServiceLocation[] = [
  {
    id: ULTRA_SERVICE_LOCATION_ENUM.MAGIC_CITY,
    name: Strings.MAGIC_CITY,
    isEnabled: true,
  },
  {
    id: ULTRA_SERVICE_LOCATION_ENUM.AVENTURA,
    name: Strings.AVENTURA,
    isEnabled: true,
  },
  // {
  //   id: ULTRA_SERVICE_LOCATION_ENUM.BRICKBELL,
  //   name: "Brickbell",
  //   isEnabled: false,
  // },
];

export const UltraServiceUrlMap = new Map<number, UltraServiceLocationUrl[]>([
  [
    ULTRA_SERVICE_ENUM.BOOK_COURT,
    [
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.MAGIC_CITY,
        url: "/book-court2",
      },
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.AVENTURA,
        url: process.env.REACT_APP_AVENTURA_BOOK_COURT ?? "",
      },
    ],
  ],
  [
    ULTRA_SERVICE_ENUM.BOOK_CLINIC,
    [
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.MAGIC_CITY,
        url: process.env.REACT_APP_MAGIC_CITY_BOOK_CLINIC ?? "",
      },
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.AVENTURA,
        url: process.env.REACT_APP_AVENTURA_BOOK_CLINIC ?? "",
      },
    ],
  ],
  [
    ULTRA_SERVICE_ENUM.BOOK_LESSON,
    [
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.MAGIC_CITY,
        url: process.env.REACT_APP_MAGIC_CITY_BOOK_LESSON ?? "",
      },
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.AVENTURA,
        url: process.env.REACT_APP_AVENTURA_BOOK_LESSON ?? "",
      },
    ],
  ],
  [
    ULTRA_SERVICE_ENUM.BOOK_EVENT,
    [
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.MAGIC_CITY,
        url: process.env.REACT_APP_MAGIC_CITY_BOOK_EVENT ?? "",
      },
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.AVENTURA,
        url: process.env.REACT_APP_AVENTURA_BOOK_EVENT ?? "",
      },
    ],
  ],
  [
    ULTRA_SERVICE_ENUM.BOOK_TOURNAMENT,
    [
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.MAGIC_CITY,
        url: process.env.REACT_APP_MAGIC_CITY_BOOK_TOURNAMENT ?? "",
      },
      {
        id: ULTRA_SERVICE_LOCATION_ENUM.AVENTURA,
        url: process.env.REACT_APP_AVENTURA_BOOK_TOURNAMENT ?? "",
      },
    ],
  ],
]);
export enum CourtCoverageOptionEnum {
  ZONES = "Zones",
  SIDES = "Sides",
  FRONT_BACK = "Front-Back",
}

export enum MatchStatsEnum {
  DISTANCE_RUN_IN_METER = "Distance run in meters",
  NO_OF_SHOTS = "Number of shots",
  BALL_POSSESSION = "Ball Possession",
  ATTACK = "Attack",
  DEFENSE = "Defense",
  NEUTRAL = "Neutral",
}
